export default __webpack_public_path__ + "static/media/visibility_on.6bbe4bda.svg";